import makeClass from 'clsx';

import { Themeable, ThemeType, themes } from './types';
import { dsThemeContextManager } from './context';

/**
 * getTheme utility to support to provide object containing currentTheme and currentColorScheme.
 *
 * @param props - see typescript definition
 * @param context - see typescript definition
 * @param styles - The css modules styles for the component
 */
export const getTheme = (
  props: Themeable,
  context: Themeable,
  styles: Record<string, string> = {}
) => {
  let currentTheme =
    props.theme ||
    context.theme ||
    dsThemeContextManager.getCurrentTheme() ||
    'intuit';

  // This is in place for legacy code that uses a "default" theme
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (currentTheme === 'default') {
    currentTheme = 'intuit';
  }

  const currentColorScheme =
    props.colorScheme || context.colorScheme || 'light';

  const themeClass = makeClass(
    styles[currentTheme],
    styles[currentColorScheme]
  );

  return {
    currentTheme,
    currentColorScheme,
    themeClass
  };
};

/**
 * Determines if provided theme name is a valid theme
 *
 * @deprecated Typecheck using ThemeType instead
 */
export const isValidTheme = (theme: ThemeType) => {
  return themes.includes(theme);
};
